import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import moment from 'moment';
import { MenuItem } from '@material-ui/core';
import { FormTextField } from '../Form';
import { listAuctions } from '../../actions';
import { AUCTION_END_FORMATTING } from '../../constants';

class AuctionFilter extends Component {
  componentWillMount() {
    const { fetchAuctions } = this.props;
    fetchAuctions();
  }

  render() {
    const { auctions, displayType, showAll = true, multiple = false } = this.props;
    const auctionsCopy = [...auctions];
    auctionsCopy.sort((a, b) => {
      if (a.id > b.id) {
        return -1;
      }
      if (a.id < b.id) {
        return 1;
      }
      return 0;
    });
    return (
      <Field
        component={FormTextField}
        name="auction_id"
        label="Filter by Auction"
        select
        style={{minWidth: '160px'}}
        inputProps={{multiple}}
      >
        {showAll && <MenuItem value="">All</MenuItem>}
        {auctionsCopy.map((item, i) => {
          if (displayType === 'id') {
            return (
              <MenuItem value={item.id} key={i}>
                {item.id}
              </MenuItem>
            );
          }
          return (
            <MenuItem value={item.id} key={i}>
              {moment
                .utc(item.date_end)
                .local()
                .format(AUCTION_END_FORMATTING)}
            </MenuItem>
          );
        })}
      </Field>
    );
  }
}

AuctionFilter.defaultProps = {
  displayType: 'date'
};

const mapStateToProps = state => ({
  auctions: state.auctions.itemsData.rows
});

const mapDispatchToProps = dispatch => ({
  fetchAuctions: params => dispatch(listAuctions(params).request)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuctionFilter);
